import { z } from 'zod';

// Zod probes `new Function` when it constructs its first object schema, and the Content-Security-Policy reports
// that probe as a violation. main.tsx imports this module before any module that defines a schema.
z.config({ jitless: true });
